import React from "react";
import { Navigate } from "react-router-dom";

import AuthPage from "../pages/AuthPage";
import PortalPage from "../pages/PortalPage";
import DepartmentsPage from "../pages/Settings/Departments/DepartmentsPage";
import UsersPage from "../pages/Settings/User/UsersPage";
import TrainingCategoriesPage from "../pages/Settings/TrainingCategories/TrainingCategoriesPage";
import RolesPermissionsPage from "../pages/Settings/RolesPermissions/RolesPermissionsPage";
import DesignationPage from "../pages/Settings/Designation/DesignationPage";
import BudgetCodesPage from "../pages/Settings/BudgetCodes/BudgetCodesPage";
import ClaimPolicyPage from "../pages/Settings/ClaimPolicy/ClaimPolicyPage";
import AuditTrailPage from "../pages/Settings/AuditTrail/AuditTrailPage";
import CreditCardsPage from "../pages/Settings/CreditCards/CreditCardsPage";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import ReportsPage from "../pages/Report/ReportsPage";
import TravelListPage from "../pages/Travel/TravelListPage";
import TravelDetailPage from "../pages/Travel/TravelDetailPage";
import TravelCreatePage from "../pages/TravelCreatePage";
import TravelAmendPage from "../pages/Travel/TravelAmendPage";
import TravelRequestCreateStep2 from "../pages/Travel/TravelRequestCreateStep2";
import TravelRequestCreateStep3 from "../pages/Travel/TravelRequestCreateStep3";
import TravelRequestCreateStep4 from "../pages/Travel/TravelRequestCreateStep4";
import TravelRequestCreateStep5 from "../pages/Travel/TravelRequestCreateStep5";
import TrainingListPage from "../pages/Training/TrainingListPage";
import TrainingDetailPage from "../pages/Training/TrainingDetailPage";
import TrainingEvaluatePage from "../pages/Training/TrainingEvaluatePage";
import TrainingRequestCreate from "../pages/Training/TrainingRequestCreate";
import ClaimListPage from "../pages/Claim/ClaimListPage";
import ClaimDetailPage from "../pages/Claim/ClaimDetailPage";
import ClaimCreateSelectType from "../pages/Claim/ClaimCreateSelectType";
import ClaimCreateCash from "../pages/Claim/ClaimCreateCash";
import ClaimCreateLocalTravel from "../pages/Claim/ClaimCreateLocalTravel";
import ClaimCreateOverseasTravel from "../pages/Claim/ClaimCreateOverseasTravel";
import ApprovalQueuePage from "../pages/Approvals/ApprovalQueuePage";

const AppRoute = ({ children, requiredPermission }) => children;

const authProtectedRoutes = [
  { path: "/dashboard", component: <DashboardPage /> },
  { path: "/profile", component: <PortalPage page="users" /> },
  { path: "/travel", component: <TravelListPage /> },
  { path: "/travel/create", component: <TravelCreatePage /> },
  { path: "/travel/create/step-1", component: <TravelCreatePage /> },
  { path: "/travel/create/step-2", component: <TravelRequestCreateStep2 /> },
  { path: "/travel/create/step-3", component: <TravelRequestCreateStep3 /> },
  { path: "/travel/create/step-4", component: <TravelRequestCreateStep4 /> },
  { path: "/travel/create/step-5", component: <TravelRequestCreateStep5 /> },
  { path: "/travel/:id", component: <TravelDetailPage /> },
  { path: "/travel/:id/amend", component: <TravelAmendPage /> },
  { path: "/training/request", component: <TrainingListPage /> },
  { path: "/training/request/create", component: <TrainingRequestCreate /> },
  { path: "/training/request/:id", component: <TrainingDetailPage /> },
  { path: "/training/request/:id/evaluate", component: <TrainingEvaluatePage /> },
  { path: "/training/evaluations", component: <TrainingEvaluatePage /> },
  { path: "/training/evaluations/:id", component: <TrainingEvaluatePage /> },
  { path: "/claim", component: <ClaimListPage /> },
  { path: "/claim/credit-card-statements", component: <CreditCardsPage view="statements" /> },
  { path: "/claim/create", component: <ClaimCreateSelectType /> },
  { path: "/claim/create/cash", component: <ClaimCreateCash /> },
  { path: "/claim/create/credit-card", component: <Navigate to="/claim/create" replace /> },
  { path: "/claim/create/local-travel", component: <ClaimCreateLocalTravel /> },
  { path: "/claim/create/overseas-travel", component: <ClaimCreateOverseasTravel /> },
  { path: "/claim/create/meal", component: <Navigate to="/claim/create" replace /> },
  { path: "/claim/create/mileage", component: <Navigate to="/claim/create" replace /> },
  { path: "/claim/:id", component: <ClaimDetailPage /> },
  { path: "/approvals", component: <ApprovalQueuePage /> },
  { path: "/approvals/:id", component: <ApprovalQueuePage /> },
  { path: "/approval", component: <Navigate to="/approvals" /> },
  { path: "/finance", component: <PortalPage page="dashboard" /> },
  { path: "/notification", component: <PortalPage page="dashboard" /> },
  { path: "/notification/:id", component: <PortalPage page="dashboard" /> },
  { path: "/settings", component: <PortalPage page="users" /> },
  { path: "/report", component: <ReportsPage /> },
  { path: "/reports", component: <Navigate to="/report" /> },
  { path: "/report/:id", component: <ReportsPage /> },
  { path: "/users", component: <UsersPage /> },
  { path: "/departments", component: <DepartmentsPage /> },
  { path: "/role", component: <RolesPermissionsPage /> },
  { path: "/designation", component: <DesignationPage /> },
  { path: "/tcategories", component: <TrainingCategoriesPage /> },
  { path: "/audit", component: <AuditTrailPage /> },
  { path: "/budget", component: <BudgetCodesPage /> },
  { path: "/claimpolicy", component: <ClaimPolicyPage /> },
  { path: "/credit-cards", component: <CreditCardsPage view="setup" /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <AuthPage mode="login" /> },
  { path: "/login", component: <AuthPage mode="login" /> },
  { path: "/forgot-password", component: <AuthPage mode="forgot" /> },
  { path: "/reset-password", component: <AuthPage mode="forgot" /> },
  { path: "/maintenance", component: <AuthPage mode="login" /> },
  { path: "/404", component: <AuthPage mode="login" /> },
  { path: "/not-authorized", component: <AuthPage mode="login" /> },
];

export { authProtectedRoutes, publicRoutes, AppRoute };
